<div class="killscreen-overlay overlay">
  <div class="killscreen-title">{{ 'profile.other.rollDied' | translate }}</div>
  <div class="killscreen-subtitle">{{ 'profile.other.rollDiedCountPrefix' | translate }} {{ survivedCount }}</div>
</div>
